import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '@/utils/googleAnalytics';
import { HotBrandsSkeleton } from '@/components/Skeleton';

const HotBrandsSection = ({ brands, isLoading = false }) => {
  const { t } = useTranslation();

  const handleBrandClick = (brand) => {
    trackEvent('brand_click', {
      brand_id: brand.id,
      brand_name: brand.localizedName
    });
  };

  if (isLoading) {
    return <HotBrandsSkeleton title={t('home.sections.hot_brands')} />;
  }

  return (
    <div className="w-full">
      <h2 className="text-2xl font-bold text-[#111111] mb-6">{t('home.sections.hot_brands')}</h2>

      <div className="flex flex-col gap-6 mb-6">
        {brands.map((brand) => (
          <Link
            key={brand.id}
            to={`/brands/${brand.id}`}
            className="flex items-center gap-4 hover:bg-[#f4f4f4] rounded-md p-2"
            onClick={() => handleBrandClick(brand)}
          >
            <img 
              src={brand.logo?.url} 
              alt={brand.localizedName} 
              className="w-10 h-[26px] object-contain"
            />
            <span className="text-xs text-[#111111] flex-1">
              {brand.localizedName}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HotBrandsSection; 